const NUXT_ASSET_PATH_PATTERN = /^\/_nuxt\/(?:.+\.(?:css|js|mjs)|builds\/meta\/.+\.json)$/i

const getUrl = (sourceUrl: string, currentOrigin: string) => {
  try {
    return new URL(sourceUrl, currentOrigin || undefined)
  } catch {
    return null
  }
}

const splitRelTokens = (rel: string) => {
  return rel
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean)
}

export const isRecoverableNuxtAssetUrl = (sourceUrl: string, currentOrigin: string) => {
  const url = getUrl(sourceUrl, currentOrigin)
  if (!url) return false
  if (currentOrigin && url.origin !== currentOrigin) return false

  return NUXT_ASSET_PATH_PATTERN.test(url.pathname)
}

export const isRecoverableNuxtAssetLink = (
  rel: string,
  asValue: string,
  href: string,
  currentOrigin: string
) => {
  if (!isRecoverableNuxtAssetUrl(href, currentOrigin)) return false

  const relTokens = splitRelTokens(rel)
  if (relTokens.includes('prefetch')) return false
  if (relTokens.includes('stylesheet') || relTokens.includes('modulepreload')) return true

  const preloadAs = asValue.toLowerCase()
  return relTokens.includes('preload') && ['script', 'style', 'fetch'].includes(preloadAs)
}
